import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 18.75a3 3 0 1 0 6 0 3 3 0 1 0-6 0m8.3-5.303a7.5 7.5 0 0 0-10.606 0m13.791-3.182a12 12 0 0 0-16.97 0"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M23.25 6.681a16.5 16.5 0 0 0-22.5 0"
    }, null, -1)
  ]));
}
const computerDeviceNetworkWifiConnection = { render };
export {
  computerDeviceNetworkWifiConnection as default,
  render
};
//# sourceMappingURL=computer-device-network-wifi-connection.svg.js.map
